import { DateTimePropertyComponent } from '../components/DateTimePropertyComponent';
import { PropertySchema } from '../PropertySchema';

export const DateTimeProperty = new PropertySchema('dateTime', {
  component: DateTimePropertyComponent,
});
